import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { binghamtonConfig } from "./data";

export default function BinghamtonPage() {
  return <CityPageTemplate config={binghamtonConfig} />;
}